import { API, unwrapData } from '../axios-instance'
import { SlackIdentity } from './types'

export const createSlackIdentity = async () => {
  return await API.post<SlackIdentity>('/identity/slackIdentities').then(unwrapData)
}

export const deleteSlackIdentity = async () => {
  return await API.delete<boolean>('/identity/slackIdentities').then(unwrapData)
}

export const getSlackIdentity = async () => {
  return await API.get<boolean>('/identity/slackIdentities').then(unwrapData)
}
